import {
  useWSSnackbar,
  WSButton,
  WSFlexBox,
  WSInfoBox,
  WSPill,
  WSText
} from "@wingspanhq/fe-component-library";
import { useCallback, useState } from "react";
import { useDownloadPrivateDocument } from "../../../query/files/mutations";
import { components } from "../../../services/api/resourceEvents/types";
import { filesService } from "../../../services/files";
import { downloadFileFromBuffer } from "../../../utils/files";

type Props = {
  event: components["schemas"]["IResourceEvent"];
  isCompact?: boolean;
};
export const EventContent: React.FC<Props> = props => {
  const [downloadDocument, downloadDocumentMeta] = useDownloadPrivateDocument();
  const { openSnackbar } = useWSSnackbar();
  const [showMore, setShowMore] = useState(false);

  const handleDownload = useCallback(
    async (fileId: string) => {
      const file = await filesService.member.private.get(fileId);

      await downloadDocument(file.fileId, {
        onSuccess: blob => {
          downloadFileFromBuffer(blob, file?.filename, file.mimetype);
          openSnackbar({
            message: "File downloaded successfully",
            type: "success"
          });
        },
        onError: () => {
          openSnackbar({
            message: "Download failed",
            type: "warning"
          });
        }
      });
    },
    [downloadDocument, openSnackbar]
  );

  const hasExtraContent =
    props.event.description ||
    props.event.note ||
    props.event.attachmentId ||
    props.event.actorName;
  const showDetails = hasExtraContent && (!props.isCompact || showMore);
  const showSeeMoreLink = hasExtraContent && props.isCompact && !showMore;
  const isActorDifferentFromOwner =
    props.event.actorName !== props.event.userName;

  return (
    <>
      {props.event.title && (
        <WSText.ParagraphSm color="gray600">
          {props.event.title}
          {props.event.attachmentId && (
            <WSButton.Link
              size="S"
              ml="S"
              onClick={() => handleDownload(props.event.attachmentId!)}
              loading={downloadDocumentMeta.isLoading}
            >
              Download
            </WSButton.Link>
          )}
        </WSText.ParagraphSm>
      )}
      {showDetails && (
        <>
          {props.event.description && (
            <WSInfoBox mt="M">{props.event.description}</WSInfoBox>
          )}
          {props.event.note && (
            <>
              <WSText.ParagraphSm color="gray600" mt="M">
                Note
              </WSText.ParagraphSm>
              <WSInfoBox mt="M">{props.event.note}</WSInfoBox>
            </>
          )}
          {props.event.actorName && isActorDifferentFromOwner && (
            <WSFlexBox mt="M" direction="column">
              <WSFlexBox alignItems="center" mb="M">
                <WSText.ParagraphSm color="gray600">
                  Team member
                </WSText.ParagraphSm>
                <WSPill icon="lock" text="Private" theme="neutral" ml="M" />
              </WSFlexBox>
              <WSInfoBox>Action taken by {props.event.actorName}</WSInfoBox>
            </WSFlexBox>
          )}
        </>
      )}

      {showSeeMoreLink && (
        <WSButton.Link
          size="M"
          ml="NONE"
          pl="NONE"
          onClick={() => setShowMore(true)}
        >
          See more
        </WSButton.Link>
      )}
    </>
  );
};
